import {
    FETCH_BLOCKED_USERS,
    FETCH_BLOCKED_USERS_SUCCESS,
    FETCH_BLOCKED_USERS_FAILED,
    BLOCK_USER,
    UNBLOCK_USER
  } from "../store/types";
  import { firebase } from '../config/configureFirebase';
  import { onValue, set, remove, off } from "firebase/database";
  
  export const fetchBlockedUsers = (uid) => (dispatch) => {
  
    const {
        blockedUsersRef
    } = firebase;
  
    dispatch({
      type: FETCH_BLOCKED_USERS,
      payload: null,
    });
    onValue(blockedUsersRef(uid), (snapshot) => {
      if (snapshot.val()) {
        let data = snapshot.val();
        const arr = Object.keys(data);
        dispatch({
          type: FETCH_BLOCKED_USERS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_BLOCKED_USERS_SUCCESS,
          payload: []
        });
      }
    });
  };
  
  export const blockUser = (blockerUid, blockedUid, blockedName) => (dispatch) => {
  
    const {
        blockedUserRef
    } = firebase;
  
    set(blockedUserRef(blockerUid, blockedUid), { name: blockedName, timestamp: new Date().getTime() });
    dispatch({
      type: BLOCK_USER,
      payload: { blockerUid, blockedUid, blockedName }
    });
  };
  
  export const unblockUser = (blockerUid, blockedUid) => (dispatch) => {
  
    const {
        blockedUserRef
    } = firebase;
  
    remove(blockedUserRef(blockerUid, blockedUid));
    dispatch({
      type: UNBLOCK_USER,
      payload: { blockerUid, blockedUid }
    });
  };
  
  export const stopFetchBlockedUsers = (uid) => () => {
  
    const {
        blockedUsersRef
    } = firebase;
  
    off(blockedUsersRef(uid));
  };
